import { cn } from "src/common/utils";

const GitLabIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-0.5 flex items-center justify-center")}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 380 380"
      className="w-full h-full scale-[1.16]"
    >
      <path
        d="M282.83 170.73l-.27-.69-26.14-68.22a6.81 6.81 0 00-2.69-3.24 7 7 0 00-8 .43 7 7 0 00-2.32 3.52l-17.65 54h-71.47l-17.65-54a6.86 6.86 0 00-2.32-3.53 7 7 0 00-8-.43 6.87 6.87 0 00-2.69 3.24L97.44 170l-.26.69a48.54 48.54 0 0016.1 56.1l.09.07.24.17 39.82 29.82 19.7 14.91 12 9.06a8.07 8.07 0 009.76 0l12-9.06 19.7-14.91 40.06-30 .1-.08a48.56 48.56 0 0016.08-56.04z"
        fill="#e24329"
      />
      <path
        d="M282.83 170.73l-.27-.69a88.3 88.3 0 00-35.15 15.8L190 229.25c19.55 14.79 36.57 27.64 36.57 27.64l40.06-30 .1-.08a48.56 48.56 0 0016.1-56.08z"
        fill="#fc6d26"
      />
      <path
        d="M153.43 256.89l19.7 14.91 12 9.06a8.07 8.07 0 009.76 0l12-9.06 19.7-14.91S209.55 244 190 229.25c-19.55 14.75-36.57 27.64-36.57 27.64z"
        fill="#fca326"
      />
      <path
        d="M132.58 185.84A88.19 88.19 0 0097.44 170l-.26.69a48.54 48.54 0 0016.1 56.1l.09.07.24.17 39.82 29.82L190 229.25z"
        fill="#fc6d26"
      />
    </svg>
  </div>
);

export default GitLabIcon;
